__webpack_require__.p = "https://axiombatprice.icelanddev.net/";